
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nashi-vinoteki/[code]",
      function () {
        return require("private-next-pages/nashi-vinoteki/[code]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nashi-vinoteki/[code]"])
      });
    }
  